import React from "react";
import { useCustomParams } from "../../../../hooks/useCustomParams";
import { useRemoveAllFilters } from "../../../../hooks/useRemoveAllFilters";
import { useMediaQuery } from "react-responsive";
import CustomSelectDropdown from "../../../../components/CustomSelectDropDown";
import PrimaryButton from "../../../../components/Button/Button";
import { useSelector } from "react-redux";

function LeftFilters() {
  const [status, updateStatus] = useCustomParams("status");
  const statusCount = useSelector((state) => state.ll55.count);
  const isMobile = useMediaQuery({ maxWidth: "690px" });
  const buttons = [
    { label: `Total ${statusCount?.total || ""}`, value: "" },
    { label: `No Action ${statusCount?.completed || ""}`, value: "completed" },
    { label: `Pending ${statusCount?.pending || ""}`, value: "pending" },
    {
      label: `Mold ${statusCount?.mold_required || ""}`,
      value: "mold_required",
    },
    {
      label: `Roaches ${statusCount?.roaches_required || ""}`,
      value: "roaches_required",
    },
    {
      label: `Mice/Rats ${statusCount?.mice_rats_required || ""}`,
      value: "mice_rats_required",
    },
    // {
    //   label: `Inspection Scheduled ${statusCount?.inspection_scheduled || ""}`,
    //   value: "inspection_scheduled",
    // },
  ];

  const buttons2 = [
    { label: "Total", value: "", total: statusCount?.total || "" },
    {
      label: "No Action",
      value: "completed",
      total: statusCount?.completed || "",
    },
    { label: "Pending", value: "pending", total: statusCount?.pending || "" },
    {
      label: "Mold",
      value: "mold_required",
      total: statusCount?.mold_required || "",
    },
    {
      label: "Roaches",
      value: "roaches_required",
      total: statusCount?.roaches_required || "",
    },
    {
      label: "Mice/Rats",
      value: "mice_rats_required",
      total: statusCount?.mice_rats_required || "",
    },
    // {
    //   label: "Inspection Scheduled",
    //   value: "inspection_scheduled",
    //   total: statusCount?.inspection_scheduled || "",
    // },
  ];

  return (
    <div>
      {isMobile ? (
        <CustomSelectDropdown
          options={buttons}
          label="Filter by Days"
          onSelectChange={(value) => updateStatus("date", value)}
          defaultValue={status}
        />
      ) : (
        buttons2.map((el, idx) => {
          return (
            <PrimaryButton
              variant="contained"
              key={idx}
              className={`capitalize ${
                el.value == status ? "btn-bg-grey" : "btn-bg-light-grey"
              } `}
              onClick={() => updateStatus("status", el.value)}
            >
              {el.label}{" "}
              <span
                className={`${
                  el.value == status ? "survey-count-select" : "survey-count"
                } `}
              >{` ${el.total}`}</span>
            </PrimaryButton>
          );
        })
      )}
    </div>
  );
}

export default LeftFilters;
